// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { spacing } from '@iheartjane/reefer-emotion';

import { Audit } from '@jane/business-admin/components';

const Wrapper = styled.div({
  display: 'flex',
  ...spacing({ px: 64, py: 40 }),
});

const Main = styled.div({
  width: '100%',
});

export const StoreAudit = () => {
  return (
    <Wrapper>
      <Main>
        <Audit />
      </Main>
    </Wrapper>
  );
};
